import type {TMajorActionResidenceToCashData} from '@kapitalist/contract/types'
import {skins} from '~/game/skins'
import ResidenceCard from '~/models/game/Cards/ResidenceCard'
import {PlayerGamePosition} from '~/models/game/GamePosition'
import type {TMajorActionUserFacingDescriptionData} from '~/models/game/MajorAction'
import MajorAction from '~/models/game/MajorAction'
import {mutateIf} from '~/utils/etc'
import {inTense, sentenceCase} from '~/utils/language'

export default class MajorActionResidenceToCash extends MajorAction<TMajorActionResidenceToCashData> {
  card: ResidenceCard

  constructor(data: TMajorActionResidenceToCashData) {
    super(data)
    this.card = new ResidenceCard(data.card)
  }

  public userFacingDescription({
    tense,
    skin,
    gamePosition,
  }: TMajorActionUserFacingDescriptionData): string {
    const currentPlayer =
      gamePosition instanceof PlayerGamePosition
        ? gamePosition.currentPlayer
        : undefined
    const majorActor = gamePosition.majorActorPlayer
    const dropFirstNoun = tense === 'imperativePrompt'

    return skins[skin].gameLogDescriptions.majorActions.residenceToCash({
      tense,
      actor: dropFirstNoun
        ? undefined
        : currentPlayer?.id === majorActor.id
          ? 'You'
          : majorActor.username,
      moveVerb: mutateIf(inTense(tense)('move'), dropFirstNoun, sentenceCase),
      cardName: this.card.displayName(skin),
      possessive:
        dropFirstNoun || currentPlayer?.id === majorActor.id ? 'your' : 'their',
    })
  }
}
